import { render, staticRenderFns } from "./indexH5.vue?vue&type=template&id=c96b29a2&scoped=true"
import script from "./indexH5.vue?vue&type=script&setup=true&lang=ts"
export * from "./indexH5.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./indexH5.vue?vue&type=style&index=0&id=c96b29a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96b29a2",
  null
  
)

export default component.exports